import React from 'react';
import { Link } from 'react-router-dom';
import './Inicio.css';

import whattsapp from '../../assets/whatsapp.webp';

import miuni from '../../assets/iconos_amarillos/mi uni 2.png';
import mis from '../../assets/iconos_amarillos/ver mis reportes.png';
import miescuela from '../../assets/iconos_amarillos/mi escuela 2.png';
import atencion from '../../assets/iconos_amarillos/delito.png';
import arriba from '../../assets/policia-titulo.png';
import gobiernoDigital from '../../assets/Recurso 2GOBDIGITALB.png';

import BotonEmergencia from '../../iu/botonEmergencia/botonEmergencia';

import { useUser } from '../../userContext';

const Inicio = () => {
    const { isLogged, cerrarSesion, nombre } = useUser();
    return (
        <div className='main'>
            <div className='contenido-componentes'>
                <br />
                <img className='inicio-img' alt='inicio icono' src={arriba} />
                <div className='inicio-menu'>
                    <Link
                        className='inicio-card'
                        to="/crear-reporte-delito"
                    >
                        <img className='inicio-card-img' alt='delito icono' src={atencion} />
                    </Link>
                    <Link
                        className='inicio-card'
                        to="/Crear-reporte-mi-escuela"
                    >
                        <img className='inicio-card-img' alt='mi escuela icono' src={miescuela} />
                    </Link>
                    <Link
                        className='inicio-card'
                        to="/Crear-reporte-mi-uni"
                    >
                        <img className='inicio-card-img' alt='mi uni icono' src={miuni} />
                    </Link>
                    {isLogged ? (
                        <>
                            <Link className='inicio-card' to="/mis-reportes">
                                <img className='inicio-card-img' alt='mis denuncias icono' src={mis} />
                            </Link>
                        </>
                    ) : null}
                </div>
            </div>
            <BotonEmergencia />
            {isLogged ? (
                <div className='boton-cuarto' onClick={cerrarSesion}>Cerrar sesión</div>
            ) : (
                <Link className='boton-primario' to="/login">
                    Iniciar sesión
                </Link>
            )}
            <a href="https://gobiernodigital.morelia.gob.mx/" target="_blank" rel="noopener noreferrer">
                <img className='inicio-img-digital' alt='gobierno digital icono' src={gobiernoDigital} />
            </a>
            {nombre && (
                <div className="user-name">
                    Hola {nombre}
                </div>
            )}

        </div>
    );
};

export default Inicio;
